import React, { Component } from 'react';
import Pagination from "react-js-pagination";
import Moment from 'moment';
import EditMembers from "./editMembers";
import './style.css';

class CountryUsersList extends Component {
  constructor(props){
    super(props)
    this.state={
      activePage: 1,
      countryName: '',
      totalUsers: 0,
      showEditMembersComponent: false,
      editMemberData : "",
    };
    this.editMember = this.editMember.bind(this);
    this.showCountryList = this.showCountryList.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.backMemberList = this.backMemberList.bind(this);
    this.updateProfile = this.updateProfile.bind(this);
    this.showTransactionByuserID = this.showTransactionByuserID.bind(this);
    this.userDemographics = this.userDemographics.bind(this);
  }

  componentDidMount(){
    this.setState({
      countryName : this.props.countryUsersCountData.name,
      totalUsers  : this.props.countryUsersCountData.totalUsers,
    });
  }

  editMember(data){
    this.setState({showEditMembersComponent : true, editMemberData : data});
  }

  disableMember(data){
    let removedata={};
    removedata.userId = data._id;
    removedata.adminMailId = sessionStorage.getItem('adminEmail');
    removedata.countryName = this.state.countryName,
    removedata.currentPage = this.state.activePage
    this.props.disableMember(removedata);
  }

  backMemberList(){
    this.props.getCountryUsers(this.state.countryName, this.state.activePage);
    this.setState({showEditMembersComponent : false});
  }

  updateProfile(data){
    this.props.updateProfile(data);
  }

  showCountryList(){
    this.props.showCountryList();
  }

  handlePageChange(pageNumber) {
    this.props.getCountryUsers(this.state.countryName, pageNumber);
    this.setState({activePage: pageNumber});
  }

  showTransactionByuserID(profileId){
    this.props.showTransactionByuserID(profileId);
  }

  enableMember(data){
    let dataUser={};
    dataUser.userId = data._id;
    dataUser.adminMailId = sessionStorage.getItem('adminEmail');
    dataUser.countryName = this.state.countryName,
    dataUser.currentPage = this.state.activePage
    this.props.enableMember(dataUser);
  }

  changeUserDateFormat(date){
    return Moment(date).format('YYYY-MM-DD');
  }

  userDemographics(id){
    this.props.userDemographics(id);

  }

  render(){

    let membersDataList = "";
    if(this.props.countryUsersSuccess){
    if(this.props.countryUsersData && this.props.countryUsersData.length){
        let members = this.props.countryUsersData;
        membersDataList = Object.keys(members).map((item, index) => {
        let membersItem = members[item];


        let showUserAction = ""
        if(membersItem.Is_Active === true){
          showUserAction = <button className = "edituserbtn" type="button" onClick={this.disableMember.bind(this, membersItem)}  > Deactivate </button>
        }else{
          showUserAction = <button className = "edituserbtn" type="button" onClick={this.enableMember.bind(this, membersItem)}  > Activate </button>
        }
          
        return <tr key={index} >
          <td>{index+1}</td>
          <td>{membersItem.First_name + " "+ membersItem.Last_name}</td>
          <td>{membersItem.D_O_B}</td>
          <td>{membersItem.Gender}</td>
          <td>{membersItem.Marriage_status}</td>
          <td>{membersItem.Address_line_one}</td>
          <td>{membersItem.State}</td>
          <td>{membersItem.Country}</td>
          <td>{membersItem.Pincode}</td>
          <td>{this.changeUserDateFormat(membersItem.createdAt)}</td> 
          <td>
           <td> <button className = "edituserbtn" type="button" onClick={this.editMember.bind(this, membersItem)}  > Edit </button></td>
           <td>{showUserAction}</td>
          </td>
          </tr>
        });
    }
  }else{
    membersDataList =
      <div>
      Not found  register Members please approved new Member
      </div>
  }



  let showComponent="";

  if(this.state.showEditMembersComponent){
    showComponent = <EditMembers
    userProfile = {this.state.editMemberData}
    updateProfile = {this.updateProfile}
    backMemberList = {this.backMemberList}
    showTransactionByuserID = {this.showTransactionByuserID}
    UserTranactionSuccess = {this.props.UserTranactionSuccess}
    UserTranactionData = {this.props.UserTranactionData}
    userDemographics = {this.userDemographics}
                    />
  }else{
    showComponent = <div className = "userlist">
    <div className = "userlistbackground">
        <div className = "usertable"><h1>Registerd Users List</h1></div>
          <br/><button className = "backbutton"   onClick={this.showCountryList}>Back</button>
          <div className = "autoscroll">
          <table className = "customerTable">
            <thead>
              <tr>
                <th>S. NO.</th>
                <th>Name</th>
                <th>D.O.B</th>
                <th>Gender</th>
                <th>Marriage</th>
                <th>Address</th>
                <th>State/Province</th>
                <th>Country</th>
                <th>Pincode</th>
                <th>Date Of Joining</th>
                <th>Action</th>
              </tr>
            </thead>
              <tbody>
                {membersDataList}
              </tbody>
          </table>
        </div>
          <div className="paginationCountryMemberTable">
          <Pagination
            
            activePage={this.state.activePage}
            itemsCountPerPage={5}
            totalItemsCount={this.state.totalUsers}    //total number of members
            pageRangeDisplayed={5}
            onChange={this.handlePageChange}
          />
          </div>
        </div>
  
      </div>
  }

  return (<div>
    {showComponent}
  </div>
        
    );
  }
}
export default CountryUsersList;



// WEBPACK FOOTER //
// ./src/components/country/countryUsers.js